import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import { selectors as i18nSelectors } from "reducers/i18n";
import { numberFormat, toNumber } from "util/number";

import Productselector from "pages/_components/fields/formik/Productselector";
import { func, string } from "prop-types";

class FormikProductSelector extends Component {
    static propTypes = {
        label: string,
        hintLabel: string,
        helpLabel: string,
        requiredLabel: string,
        placeholder: string,
        onChange: func,
    };

    static defaultProps = {
        label: "",
        hintLabel: "",
        helpLabel: "",
        requiredLabel: "",
        placeholder: "",
        onChange: null,
    };

    handleBlur = () => {
        const { field, form } = this.props;
        form.setFieldTouched(field.name);
    };

    handleCurrencyChange = ({ value }) => {
        const { field, form, onCurrencyChange } = this.props;
        if (onCurrencyChange) {
            onCurrencyChange(value);
        } else {
            form.setFieldValue(`${field.name}.currency`, value);
        }
    };

    handleInputChange = ({ target }) => {
        const { field, form, lang, onInputChange } = this.props;
        const { decimalSeparator } = numberFormat(lang);
        const number = toNumber(target.value, decimalSeparator);
        if (onInputChange) {
            onInputChange(number);
        } else {
            form.setFieldValue(`${field.name}.amount`, number);
        }
    };

    render() {
        const { field, form, lang } = this.props;

        const defaultFormFieldProps = {
            initialValue: "",
            data: {
                options: [
                    {
                        balance: { currency: "USD", quantity: 108950 },
                        currency: "USD",
                        frequentDestination: null,
                        id: "bc85a417643a4a6ceb6452d67d23f440c8ccae78",
                        label: "993655403 CA $",
                        minimumPayment: 0,
                        permissions: [
                            "accounts.requestCheckbook",
                            "pay.creditCard",
                            "pay.creditCard.thirdParties",
                            "pay.loan",
                            "pay.loan.thirdParties",
                            "product.read",
                            "transfer.foreign",
                            "transfer.internal",
                            "transfer.local",
                            "transfer.thirdParties",
                        ],
                        statementsLoan: null,
                        totalPayment: 0,
                        type: "CA",
                    },
                    {
                        balance: { currency: "EUR", quantity: 108950 },
                        currency: "EUR",
                        frequentDestination: null,
                        id: "9ec0e10fb06f6694e28ee6babf57d933629ff5d9",
                        label: "993655404 CC €",
                        minimumPayment: 0,
                        permissions: [
                            "accounts.requestCheckbook",
                            "pay.creditCard",
                            "pay.creditCard.thirdParties",
                            "pay.loan",
                            "pay.loan.thirdParties",
                            "product.read",
                            "transfer.foreign",
                            "transfer.internal",
                            "transfer.local",
                            "transfer.thirdParties",
                        ],
                        statementsLoan: null,
                        totalPayment: 0,
                        type: "CC",
                    },
                ],
            },
            // Default For All Required
            optionalMessageMap: { pt: "Opcional", en: "Optional", es: "Opcional" },
            readOnly: false,
            dependsOnProduct: "",
            ticketOnly: false,
            type: "",
            lang: "es",
            dateFormat: "",
            isRequired: true,
            mode: "edit",
            fieldList: { find: () => {} },
            idValidation: "",
            // Default for All not Required
            dependencies: [],
            displayDependsOn: [],
            displayType: "form-normal",
            formVersion: 1,
            note: null,
            ordinal: 1,
            showBlankOption: false,
            subType: "default",
            visible: "TRUE",
            visibleInMobile: true,
            fromBackoffice: false,
            idTransactionTicket: "",
            idActivity: "",
            labelDefault: null,
            labelMap: null,
            hintMap: null,
            helpMap: null,
            requiredErrorMap: null,
            placeholderMap: null,
        };

        return (
            <Productselector
                {...field}
                hasError={form.touched[field.name] && form.errors[field.name]}
                onCurrencyChange={this.handleCurrencyChange}
                onInputChange={this.handleInputChange}
                onBlur={this.handleBlur}
                error={form.errors[field.name] && form.errors[field.name].amount}
                {...defaultFormFieldProps}
                labelDefault={this.props.label}
                labelMap={{ pt: "", en: "", es: "", [lang]: this.props.label }}
                hintMap={{ pt: "", en: "", es: "", [lang]: this.props.hintLabel }}
                helpMap={{ pt: "", en: "", es: "", [lang]: this.props.helpLabel }}
                requiredErrorMap={{ pt: "", en: "", es: "", [lang]: this.props.requiredLabel }}
                placeholderMap={{ pt: "", en: "", es: "", [lang]: this.props.placeholder }}
                {...this.props}
                {...field.value}
                menuPlacement="bottom"
            />
        );
    }
}

const mapStateToProps = (state) => ({
    lang: i18nSelectors.getLang(state),
});

export default compose(connect(mapStateToProps))(FormikProductSelector);
